import type { SaveSecretNotes } from '../../types';
import { ensureArray, num } from '../util';

/** Parse secret notes and journal scraps found from the player node and pre-computed mail flags. */
export function parseSecretNotes(
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  player: any,
  mail: Set<string>,
  events: Set<string>,
): SaveSecretNotes {
  const allNotes = ensureArray(player.secretNotesSeen?.int).map(num);

  return {
    notesFound: allNotes.filter((n) => n < 1000),
    journalScrapsFound: allNotes.filter((n) => n >= 1000).map((n) => n - 1000),
    hasMagnifyingGlass:
      mail.has('HasMagnifyingGlass') ||
      player.hasMagnifyingGlass === true ||
      player.hasMagnifyingGlass === 'true',
    hasSeenKrobus: events.has('520702'),
  };
}
